<template>
<div class="col-6 d-flex justify-content-end">
    <div class="ml-2">
        <el-input  @keyup.native.enter="filterSearchQuery" placeholder="Buscar" v-model="filterSearch"  :class="`${getPrimaryColor} filter`" clearable>
            <button class="btn" slot="append" @click="filterSearchQuery">
                <SearchIcon class="mx-0"  size="16"  />
            </button>
        </el-input>
        <h6 class="regular" slot="append">
            Busque pelo nome ou CNPJ da empresa.<br> Ex.: <span :class="`c-${getPrimaryColor}four`"> Uni Impacta. </span>
        </h6>
    </div>
</div>
</template>

<script>
export default {
    props: {
        filterSearchProp: {
            default: ''
        },
    },
    data() {
        return {
            filterSearch: this.filterSearchProp,
        }
    },
    watch: {
        filterSearch(val) {
            if (!val.length) {
                this.$emit('emptyFilter')
            }
        }
    },
    methods: {
        filterSearchQuery() {
            this.$emit('filterSearch', this.filterSearch)
        },
        emptyStatus() {
            this.$emit('emptyFilter')
        },
    }
}
</script>

<style lang="scss" scoped>
.btn.btn-outline-grey {
    padding: 11px 16px;
    height: 40px;
}
</style>
